import { Divider, styled, Tab } from '@mui/material';
import React from 'react';
export const GlobalTabDivider = ({ index, movePlaceholder }) => {
    const hidden = index === 0 && !movePlaceholder;
    return (React.createElement(StyledTab, { sx: {
            px: hidden ? 0 : '4px',
            minWidth: 'initial',
            visibility: hidden ? 'hidden' : 'visible',
            overflow: movePlaceholder ? 'visible' : 'hidden',
        }, icon: React.createElement(Divider, { orientation: 'vertical', sx: { height: '24px', alignSelf: 'center' } }), "data-index": index.toString(), "aria-hidden": 'true', disabled: true }));
};
const StyledTab = styled(Tab)(() => ({
    maxWidth: '300px',
    maxHeight: '30px',
    padding: '3px 8px',
}));
